import type { IQuizRepository } from '@/core/domain/quiz/IQuizRepository.ts'
import type { QuizVersion } from '@/core/domain/quiz/QuizVersion.ts'

export interface CreateQuizVersionPayload {
  fromVersionId?: number
}

export class CreateQuizVersionUseCase {
  private quizRepository: IQuizRepository

  constructor(quizRepository: IQuizRepository) {
    this.quizRepository = quizRepository
  }

  async execute(quizId: number, payload: CreateQuizVersionPayload): Promise<QuizVersion> {
    return await this.quizRepository.createQuizVersion(quizId, payload)
  }
}
